// extracted by mini-css-extract-plugin
export default {"SanitizedHtml":"text-cell-module__SanitizedHtml--w8Mjo"};